import { useIsMounted } from 'seagull';
import { useIoContext } from '~/contexts';
import { useIntegration } from '~/hooks/useIntegration';
import { wait } from '~/infra/utils';
import { integrationModel } from '~/models';
import { selectors } from '~/store/state-selectors';
import { useStore, useStoreActions } from '~/store/store-context';
import { OAuthProvider } from '~/store/store.model';
import { Accounting } from '~/types/api.model';
const POLLING_TIMEOUT = 2 * 60 * 1000;
const POLLING_INTERVAL = 2000;
export function useQboInVob() {
    const { fetchIntegrationsSummary, api, updateUserClientData, fetchUserClientData } = useStoreActions();
    const authProvider = useStore(selectors.user.authProvider);
    const showQboStep = !authProvider || ![
        OAuthProvider.Intuit,
        OAuthProvider.Xero
    ].includes(authProvider);
    const { connect: connectToQbo } = useIntegration();
    const { changeLocation } = useIoContext();
    const isMounted = useIsMounted();
    const connect = async ()=>{
        const redirectUrl = "http://".concat(window.location.host, "/home");
        const linkUrl = await connectToQbo(redirectUrl);
        if (linkUrl) {
            const connectUrl = new URL(linkUrl);
            connectUrl.searchParams.append('host', window.location.host);
            changeLocation(connectUrl.toString());
        } else {
            await fetchIntegrationsSummary();
        }
    };
    const setPendingConnect = (vobQboState)=>updateUserClientData({
            vobQboState
        });
    const getState = async ()=>{
        const { vobQboState } = await fetchUserClientData();
        return vobQboState;
    };
    const getQboAccounts = async ()=>{
        await waitForReadyIntegration();
        return api.accounting.getAccounts({
            accounting: Accounting.QBO
        });
    };
    async function waitForReadyIntegration() {
        var _integrationModel_qboIntegration;
        const start = Date.now();
        let integrationsSummary = await fetchIntegrationsSummary();
        while(isMounted() && !((_integrationModel_qboIntegration = integrationModel.qboIntegration(integrationsSummary)) === null || _integrationModel_qboIntegration === void 0 ? void 0 : _integrationModel_qboIntegration.isReady()) && Date.now() - start < POLLING_TIMEOUT){
            await wait(POLLING_INTERVAL);
            integrationsSummary = await fetchIntegrationsSummary();
        }
        return integrationModel.qboIntegration(integrationsSummary);
    }
    return {
        showQboStep,
        connect,
        setPendingConnect,
        getState,
        waitForReadyIntegration,
        getQboAccounts
    };
}
